import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-ticket-created-detail',
  templateUrl: './ticket-created-detail.component.html',
  styleUrls: ['./ticket-created-detail.component.scss'],
})
export class TicketCreatedDetailComponent implements OnInit {
  public onClose: Subject<any> = new Subject();
  // initialState로 전달된 데이터는 자동으로 프로퍼티에 할당됨
  createdEvents: any[] = [];
  totalCreatedTicket: number = 0;
  // typeOfTicket 항목들
  typeOfTicketItems: { [key: string]: number } = {};
  // productCategory 항목들
  productCategoryItems: { [key: string]: number } = {};
  // resolutionType 항목들
  resolutionTypeItems: { [key: string]: number } = {};

  constructor(public bsModalRef: BsModalRef) {}

  ngOnInit(): void {
    // initialState로 전달된 createdEvents는 자동으로 this.createdEvents에 할당됨
    if (this.createdEvents && this.createdEvents.length > 0) {
      this.calculateSummary();
    }
  }

  private calculateSummary(): void {
    // 초기화
    this.totalCreatedTicket = 0;
    this.typeOfTicketItems = {};
    this.productCategoryItems = {};
    this.resolutionTypeItems = {};

    // 각 이벤트를 순회하며 집계 (ticketActivityData 신규 형식 + 기존 activityData 형식 지원)
    this.createdEvents.forEach((event) => {
      const count = event.result ?? event.count ?? 0;
      if (count) {
        this.totalCreatedTicket += count;
      }

      // ticketActivityData 신규 형식: result, serviceType, productType, category
      if (event.result != null) {
        const st = event.serviceType ?? event._id?.serviceType;
        if (st) {
          const k = String(st).toUpperCase();
          this.typeOfTicketItems[k] = (this.typeOfTicketItems[k] ?? 0) + count;
        }
        const pt = event.productType ?? event._id?.productType;
        if (pt) {
          const k = String(pt).toUpperCase();
          this.productCategoryItems[k] = (this.productCategoryItems[k] ?? 0) + count;
        }
        const cat = event.category ?? event._id?.status;
        if (cat) {
          const k = String(cat).toUpperCase();
          this.resolutionTypeItems[k] = (this.resolutionTypeItems[k] ?? 0) + count;
        }
        return;
      }

      // 기존 activityData 형식
      if (event.typeOfTicket && typeof event.typeOfTicket === 'object') {
        Object.keys(event.typeOfTicket).forEach((key) => {
          const value = event.typeOfTicket[key];
          if (typeof value === 'number') {
            const upperKey = key.toUpperCase();
            if (!this.typeOfTicketItems[upperKey]) {
              this.typeOfTicketItems[upperKey] = 0;
            }
            this.typeOfTicketItems[upperKey] += value;
          }
        });
      }
      if (event.productCategory && typeof event.productCategory === 'object') {
        Object.keys(event.productCategory).forEach((key) => {
          const value = event.productCategory[key];
          if (typeof value === 'number') {
            const upperKey = key.toUpperCase();
            if (!this.productCategoryItems[upperKey]) {
              this.productCategoryItems[upperKey] = 0;
            }
            this.productCategoryItems[upperKey] += value;
          }
        });
      }
      if (event.resolutionType && typeof event.resolutionType === 'object') {
        Object.keys(event.resolutionType).forEach((key) => {
          const value = event.resolutionType[key];
          if (typeof value === 'number') {
            const upperKey = key.toUpperCase();
            if (!this.resolutionTypeItems[upperKey]) {
              this.resolutionTypeItems[upperKey] = 0;
            }
            this.resolutionTypeItems[upperKey] += value;
          }
        });
      }
    });
  }

  // typeOfTicket 항목들 반환 (0이 아닌 값만)
  getTypeOfTicketEntries(): Array<{ key: string; value: number }> {
    return Object.keys(this.typeOfTicketItems)
      .filter((key) => this.typeOfTicketItems[key] > 0)
      .map((key) => ({ key, value: this.typeOfTicketItems[key] }))
      .sort((a, b) => a.key.localeCompare(b.key));
  }

  // productCategory 항목들 반환 (0이 아닌 값만)
  getProductCategoryEntries(): Array<{ key: string; value: number }> {
    return Object.keys(this.productCategoryItems)
      .filter((key) => this.productCategoryItems[key] > 0)
      .map((key) => ({ key, value: this.productCategoryItems[key] }))
      .sort((a, b) => a.key.localeCompare(b.key));
  }

  // resolutionType 표시 라벨 변환 (goodsDelivered -> GOODS DELIVERED)
  private toResolutionDisplayKey(key: string): string {
    if (key === 'GOODSDELIVERED') {
      return 'GOODS DELIVERED';
    }
    return key;
  }

  // resolutionType 항목들 반환 (0이 아닌 값만)
  getResolutionTypeEntries(): Array<{ key: string; value: number }> {
    return Object.keys(this.resolutionTypeItems)
      .filter((key) => this.resolutionTypeItems[key] > 0)
      .map((key) => ({
        key: this.toResolutionDisplayKey(key),
        value: this.resolutionTypeItems[key]
      }))
      .sort((a, b) => a.key.localeCompare(b.key));
  }

  close(): void {
    this.onClose.next(null);
    this.bsModalRef.hide();
  }
}
